window.ANIMATION_CONFIG = {
  DEFAULT_DURATION: 400,  // 기본 애니메이션 지속 시간 (ms)
  DEFAULT_DELAY: 150      // 기본 애니메이션 지연 시간 (ms)
};

function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setScreenSize();
window.addEventListener('resize', setScreenSize);

/**
 * 페이드 인 함수
 * @param {HTMLElement} el - 페이드 인/아웃할 요소
 * @param {number} duration - 페이드 인/아웃 시간 (ms)
 * @param {string} display - 페이드 인/아웃 시 요소의 display 속성 (기본값: 'block')
 */
function fadeIn(el, duration = 400, display = 'block') {
    el.style.removeProperty('display');
    if (getComputedStyle(el).display === 'none') el.style.display = display;
    setTimeout(() => {
        el.style.opacity = 0;
        // el.style.visibility = 'visible';
        el.style.transition = `opacity ${duration}ms ease`;
        requestAnimationFrame(() => { el.style.opacity = 1; });
    }, 150);
}

/**
 * 페이드 아웃 함수
 * @param {HTMLElement} el - 페이드 아웃할 요소
 * @param {number} duration - 페이드 아웃 시간 (ms)
 * @param {boolean} is_display - 페이드 아웃 시 요소의 display 속성 제거 여부 (기본값: true)
 */
function fadeOut(el, duration = 400, is_display = true) {
    el.style.opacity = getComputedStyle(el).opacity;
    el.style.transition = `opacity ${duration}ms ease`;
    requestAnimationFrame(() => { el.style.opacity = 0; });
    setTimeout(() => {
        if(is_display) {
            el.style.display = 'none';
        }
        // el.style.visibility = 'hidden';
    }, duration + 150);
}

/**
 * 페이드 토글 함수
 * @param {HTMLElement} el - 페이드 토글할 요소
 * @param {number} duration - 페이드 토글 시간 (ms)
 * @param {string} display - 페이드 토글 시 요소의 display 속성 (기본값: 'block')
 */
function fadeToggle(el, duration = 400, display = 'block') {
    const hidden = getComputedStyle(el).display === 'none' || getComputedStyle(el).opacity === '0';
    hidden ? fadeIn(el, duration, display) : fadeOut(el, duration);
}

/**
 * iOS 스크롤 방지를 위한 변수 및 함수
 */
let savedScrollY = 0;

function lockBodyScroll() {
    savedScrollY = window.scrollY; // 현재 스크롤 위치 저장
    document.documentElement.classList.add('open-modal');
    
    // body를 고정시켜 스크롤 방지
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';
}

function unlockBodyScroll() {
    document.documentElement.classList.remove('open-modal');
    
    // 스타일 해제 및 스크롤 위치 복구
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
}

/**
 * 모달 열기 함수
 * @param {string} modal - 모달 이름
 */
function openModal(modal) {
    // .modal-wrapper 모두 닫고 .modal-wrapper[data-modal="modal"] 열기
    const modalWrappers = document.querySelectorAll('.modal-wrapper');
    modalWrappers.forEach(modalWrapper => {
        modalWrapper.style.display = 'none';
        modalWrapper.classList.remove('open');
        const bgModal = modalWrapper.querySelector('.bg-modal');
        if(bgModal) {
            bgModal.style.opacity = 0
        }
    });

    const nowModalWrapper = document.querySelector(`.modal-wrapper[data-modal="${modal}"]`);
    nowModalWrapper.classList.add('open');
    fadeIn(nowModalWrapper, 400);
    lockBodyScroll(); // 수정됨: 스크롤 잠금 함수 호출
    const bgModal = nowModalWrapper.querySelector('.bg-modal');
    if(bgModal) {
        setTimeout(() => {
            bgModal.style.opacity = 0.5
        }, 400);
    }
}

/**
 * 모달 닫기 함수
 * @param {string} modal - 모달 이름
 */
function closeModal(modal) {
    const modalWrapper = document.querySelector(`.modal-wrapper[data-modal="${modal}"]`);
    fadeOut(modalWrapper, 400);
    modalWrapper.classList.remove('open');
    unlockBodyScroll(); // 수정됨: 스크롤 잠금 해제 함수 호출

}

// 모달 열기 이벤트 리스너
document.addEventListener('click', (e) => {
    if(e.target.classList.contains('modal-trigger')) {
        const modal_name = e.target.dataset.modal;
        if (modal_name) {
            const now_modal = document.querySelector(`.modal-wrapper[data-modal="${modal_name}"]`);
            if(now_modal.classList.contains('open')) {
                closeModal(modal_name);
            } else {
                openModal(modal_name);
            }
        }
    }

    // 모달 닫기 이벤트 리스너
    if(e.target.classList.contains('modal-close')) {
        const modal_name = e.target.dataset.modal;
        if (modal_name) {
            closeModal(modal_name);
        }
    }
});

/**
 * 사이드 모달 열기 함수
 */
function handleSideModalOpen(type) {
    const sideModal = document.querySelector(`.side-modal[data-modal="${type}"]`);
    const bgSideModal = document.querySelector(`.side-modal[data-modal="${type}"] .bg-side-modal`);

    sideModal.classList.add('active');
    setTimeout(() => {
        bgSideModal.style.opacity = 0.5;
        lockBodyScroll(); // 수정됨: 스크롤 잠금 함수 호출
    }, 350);
}

/**
 * 상품 상세 사이드 모달 열기 함수
 */
function handleProductSideModalOpen(type) {
    const productSideModal = document.querySelector('.product-side-modal');
    const bgProductSideModal = document.querySelector('.bg-product-side-modal');
    const allModalContents = document.querySelectorAll('.side-modal-content');
    const nowModalContent = document.querySelector(`.side-modal-content[data-modal="${type}"]`);

    allModalContents.forEach(content => {
        content.classList.add('hidden');
    });
    productSideModal.classList.add('active');
    nowModalContent.classList.remove('hidden');
    setTimeout(() => {
        bgProductSideModal.style.opacity = 0.5;
        lockBodyScroll(); // 수정됨: 스크롤 잠금 함수 호출
    }, 350);
}

/**
 * 상품 상세 사이드 모달 닫기 함수
 */
function handleProductSideModalClose() {
    const productSideModal = document.querySelector('.product-side-modal');
    const bgProductSideModal = document.querySelector('.bg-product-side-modal');
    bgProductSideModal.style.opacity = 0;
    setTimeout(() => {
        productSideModal.classList.remove('active');
        unlockBodyScroll(); // 수정됨: 스크롤 잠금 해제 함수 호출
    }, 200);
}

/**
 * 사이드 모달 닫기 함수
 */
function handleSideModalClose(type = null) {
    const sideModal = document.querySelectorAll('.side-modal');
    sideModal.forEach(modal => {
        if(modal.classList.contains('active') || (type && modal.dataset.modal === type)) {
            const bgSideModal = modal.querySelector('.bg-side-modal');
            if(bgSideModal) {
                bgSideModal.style.opacity = 0;
            }

            setTimeout(() => {
                modal.classList.remove('active');
                unlockBodyScroll(); // 수정됨: 스크롤 잠금 해제 함수 호출
            }, 200);
        }
    });
}


// ----- 페이지 이동 시, 페이드 인/아웃 전환으로 화면 이동하는 기능 코드 start -----
// 내부 링크 여부 판단
function isInternalLink(a) {
    try {
    const u = new URL(a.href, location.href);
    return u.origin === location.origin;
    } catch { return false; }
}

// 새 스크립트 실행(주입된 영역 내 scripts  재실행)
function executeScripts(scope) {
    const scripts = scope.querySelectorAll('script');
    scripts.forEach((oldS) => {
    const s = document.createElement('script');
    // 복제 속성
    [...oldS.attributes].forEach(attr => s.setAttribute(attr.name, attr.value));
    if (oldS.src) {
        s.src = oldS.src;
    } else {
        s.textContent = oldS.textContent;
    }
    oldS.replaceWith(s);
    });
}

// 링크 인터셉트
document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;
    if (a.hasAttribute('download')) return;
    if (a.target && a.target !== '_self') return;
    if (a.dataset.noSpa !== undefined) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!isInternalLink(a)) return;
    if(a.classList.contains('btn-language')) return;
    if(a.classList.contains('filter-anchor')) return;

    const url = a.getAttribute('href');
    if (!url || url.startsWith('#')) return;

    e.preventDefault();
        if(window.saveScrollPosition) window.saveScrollPosition();
        const spa = document.getElementById('spa-root');
        fadeOut(spa, window.ANIMATION_CONFIG.DEFAULT_DURATION, false); // theme.liquid에 있는 유틸 활용
    setTimeout(() => {
        location.href = url;
    }, window.ANIMATION_CONFIG.DEFAULT_DURATION + window.ANIMATION_CONFIG.DEFAULT_DELAY);
}, true);

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const spa = document.getElementById('spa-root');
        if(spa) {
            fadeIn(spa, window.ANIMATION_CONFIG.DEFAULT_DURATION);
        }
    }, window.ANIMATION_CONFIG.DEFAULT_DELAY);
});

// 뒤로가기/앞으로가기 시 페이드인 효과 적용
window.addEventListener('pageshow', (e) => {
    // bfcache(back-forward cache)에서 복원된 경우
    if (e.persisted) {
        const spa = document.getElementById('spa-root');
        if(spa) {
            // 뒤로가기로 돌아온 경우 즉시 페이드인
            spa.style.opacity = 0;
            spa.style.display = 'block';
            setTimeout(() => {
                fadeIn(spa, window.ANIMATION_CONFIG.DEFAULT_DURATION);
            }, window.ANIMATION_CONFIG.DEFAULT_DELAY);
        }
    }
});
// ----- 페이지 이동 시, 페이드 인/아웃 전환으로 화면 이동하는 기능 코드 end -----
/**
 * Get the current search params as an object
 * @returns {Object} - The current search params as an object
 * @example
 * {
 *     "sort_by": "price-ascending",
 *     "page": "1",
 *     "limit": "10",
 * }
 */
function getNowSearchParams() {
    const url = new URL(window.location.href);
    const params = makeSearchParamsObject(url.searchParams.entries());
    return params;
}

/**
 * Make the search params as an object
 * @param {Array} entries - The search params as an array
 * @returns {Object} - The search params as an object
 * @example
 * {
 *     "sort_by": ["price-ascending"],
 *     "page": ["1"],
 *     "limit": ["10"],
 * }
 */
function makeSearchParamsObject(entries) {
    const params = {};
    for(const [key, value] of entries) {
        if(params[key]){
            params[key] = [...params[key], value];
        }else{
            params[key] = [value];
        }
    }
    return params;
}

/**
 * Make the search params as a string
 * @param {Object} params - The search params as an object
 * @returns {String} - The search params as a string
 * @example
 * "sort_by=price-ascending&page=1&limit=10"
 */
function makeSearchParamsString(params) {
    let searchParamsString = '';
    for(const [key, value] of Object.entries(params)) {
        const and_sign =  '&';
        if(Array.isArray(value)){
            value.forEach((v, i) => {
                searchParamsString += `${and_sign}${key}=${v}`;
            });
        }else{
            searchParamsString += `${and_sign}${key}=${value}`;
        }
    }
    return searchParamsString.slice(1);
}

/**
 * 페이지네이션 클릭 함수
 * @param {number} pg - 페이지 번호
 * @param {string} template - 템플릿 이름
 */
function handlePaginationClick(pg, template, type = null) {
    const params = getNowSearchParams();
    params.page = [parseInt(pg)];
    const now_search_params = makeSearchParamsString(params);
    const new_url = `${window.location.pathname}?${now_search_params}`;
    if(template.includes('collection')) {
        updateFilterOptionHtml(new_url);
    } else if(template.includes('search')) {
        let type_param = type ? '&type='+type : 'type=product';
        updateSearchHtml(new_url+type_param);
    } else {
        location.href = new_url;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    handleScrollPosition();
});

/**
 * 스크롤 위치 저장 및 복원 함수
 */
function handleScrollPosition() {
    var KEY_PREFIX = 'scroll-pos:';
    var currentKey = KEY_PREFIX + window.location.pathname + window.location.search;

    function saveScrollPosition() {
        try {
            var pos = {
                x: window.scrollX || window.pageXOffset || 0,
                y: window.scrollY || window.pageYOffset || 0
            };
            sessionStorage.setItem(currentKey, JSON.stringify(pos));
        } catch (e) {}
    }
    window.saveScrollPosition = saveScrollPosition;

    function restoreScrollPosition() {
        try {
        var raw = sessionStorage.getItem(currentKey);
        if (!raw) return;
        var pos = JSON.parse(raw);
        if (!pos || typeof pos.y !== 'number') return;

        // Wait a tick to ensure layout is ready
        window.requestAnimationFrame(function () {
            var headerOffset = 80; // 픽셀
            window.scrollTo(pos.x || 0, Math.max((pos.y || 0) - headerOffset, 0));
        });
        } catch (e) {}
    }

    // Save when leaving the page (navigation away)
    window.addEventListener('beforeunload', saveScrollPosition);

    // Save on scroll (throttled)
    var ticking = false;
    window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
            saveScrollPosition();
            ticking = false;
        });
    }, { passive: true });

    // 뒤로가기/앞으로가기 여부 확인 함수
    function isBackForward() {
        try {
            if (window.performance) {
                // 최신 브라우저 표준
                if (window.performance.getEntriesByType) {
                    const nav = window.performance.getEntriesByType('navigation');
                    if (nav && nav.length > 0) {
                        return nav[0].type === 'back_forward';
                    }
                }
                // 구형 브라우저 호환 (Deprecated)
                if (window.performance.navigation) {
                    return window.performance.navigation.type === 2;
                }
            }
        } catch (e) {
            console.warn('Error checking navigation type:', e);
        }
        return false;
    }

    // pageshow 이벤트 핸들러
    window.addEventListener('pageshow', function (event) {
        try {
            // bfcache(persisted)에서 복원됐거나, 뒤로가기/앞으로가기(back_forward)인 경우에만 복원
            if (event.persisted || isBackForward()) {
                restoreScrollPosition();
            }
        } catch (e) {
            console.error('Error in pageshow handler:', e);
        }
    });

    // 페이지 로드 완료 시 체크
    function onLoadCheck() {
        try {
            if (isBackForward()) {
                restoreScrollPosition();
            }
        } catch (e) {
            console.error('Error in onLoadCheck:', e);
        }
    }

    try {
        if (document.readyState === 'complete') {
            onLoadCheck();
        } else {
            window.addEventListener('load', onLoadCheck);
        }
    } catch (e) {
        console.error('Error setting up load listener:', e);
    }
}

document.addEventListener('click', function(e) {
    const target = e.target.closest('.currency-converter-chooser-item');

    if (target) {
        const currencyConverterChooserActiveItem = target.parentNode.querySelector('.currency-converter-chooser-item.active');
        if(currencyConverterChooserActiveItem) {
            currencyConverterChooserActiveItem.classList.remove('active');
        }
        target.classList.add('active');
    }

});

// 처음 환율 변환기 현재 통화에 맞는 active 클래스 추가를 위한 observer 설정
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
                if (node.classList.contains('currency-converter-chooser-item') || node.querySelector('.currency-converter-chooser-item')) {
                    const items = document.querySelectorAll('.currency-converter-chooser-item');
                    items.forEach(item => {
                        // item style에서 font-weight: bold;가 있으면 class에 active를 추가
                        if(item.style.fontWeight === 'bold') {
                            item.classList.add('active');
                            observer.disconnect();
                        }
                    })
                }
            }
        });
    });
});

observer.observe(document.body, { childList: true, subtree: true });